import { useImpersonation } from '@app/core/auth/impersonation';
import { useEffect } from 'react';
import { getUserDisplayName } from '../../../helpers/user';
import { useAuth } from '../../auth/authentication/hooks/useAuth';
import { getBugsnagClient } from './bugsnag';

/**
 * Identifies the current user in Bugsnag when they log in, and updates
 * metadata when impersonation changes. Mirrors the behaviour of usePostHogIdentify.
 * User and metadata are set on the Bugsnag client so they are attached to
 * all subsequent error reports.
 */
export function useBugsnagIdentify() {
  const { user, client } = useAuth();
  const { impersonatedUser } = useImpersonation();
  const bugsnag = getBugsnagClient();

  useEffect(() => {
    if (!bugsnag) {
      return;
    }

    bugsnag.setUser(user.id, user.email, getUserDisplayName(user));
    bugsnag.addMetadata('user', {
      client: client?.slug,
      role: user.role,
      impersonatedUser: impersonatedUser?.email ?? null,
    });
  }, [user, client, impersonatedUser]);
}
